export default {
  events: {
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  eventsContainer: {
    overflow: 'auto',
    px: 2,
  },
  title: {
    fontWeight: 400,
    mb: 3,
    p: 2,
    pb: 0,
  },
  author: {
    fontWeight: 400,
    color: '#000',
    mb: '2px',
  },
  descr: {
    fontWeight: 300,
    color: '#000',
  },
  status: {
    mt: 0.5,
    color: 'text.grey.blue_2',
  },
  link: {
    display: 'block',
    color: 'text.brand.color_2',
    fontWeight: 400,
    mt: 2,
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: 'text.grey.blue_2',
    mt: '50px',
  },
  emptyMessage: {
    mb: 1.9,
  },
  noEvents: {
    '& svg': {
      height: '36px',
      width: '39px',
    },
  },
  eventItem: {
    mb: 2.5,
  },
  divider: {
    mt: 2,
  },
  icon: {
    height: '10px',
  },
};
